import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { string } from 'prop-types';
import get from 'lodash/get';
import Marquee from 'react-fast-marquee';
import SvgIcon from '../../../atoms/svg-icon';
import './stock-tickr-list.m.css';
import { getUserStatus } from '../../../../helpers/utils';

const StockTickrList = (props) => {
  const { pageType } = props;
  const formattedPageType = pageType.replace(/[-\s]/g, '');
  const [isTouching, setIsTouching] = useState(false);
  const [adUnitName, setAdUnitName] = useState('');
  const userData = useSelector((state) => get(state, ['userData']));

  const handleTouchStart = () => {
    setIsTouching(true);
  };

  const handleTouchEnd = () => {
    setIsTouching(false);
  };


  const getTickerChange = (ticker) => {
    const postive = ticker.chg > 0;
    const change = postive ? `+${ticker.chg}` : ticker.chg;
    const changeP = get(ticker, ['chgp'], 0);
    const tickerChange = `${change} (${changeP}%)`;
    const arrowType = postive ? 'ic_arrow_forward_green' : 'ic_arrow_forward_red';
    return (
      <span styleName={`change ${postive ? 'positive' : 'negative'}`}>
        <SvgIcon type={arrowType} source="image" iconStyle={{ width: '12px' }} />
        {tickerChange}
      </span>
    );
  };
  const handleClick = (tickerName, pageType) => {
    const baseData = {
      event: 'trending_interaction',
      cta_text: tickerName || 'NA',
      section_name: 'market',
      user_id: userData?.userProfile?.userId || 'NA',
      user_status: getUserStatus(),
      login_type: userData?.isLoggedIn ? 'logged-in' : 'logged-out',
      page_template: pageType || 'NA',
      language_hit: 'english',
      Platform: isMobile ? 'mobile' : 'desktop',
      SiteName: 'www.ndtvprofit.com'
    };

    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push(baseData);
    } else {
      console.error('Error: window.dataLayer is not available');
    }
  };

  const [isMobile, setIsMobile] = useState(false);
  const [isLivePage, setIsLivePage] = useState(false);

  useEffect(() => {
    const pathName = window.location.pathname;
    setIsLivePage(pathName === '/live-tv');
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 767);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div styleName="market-ticker-wrap">
      <div
        styleName={`markets-ticker-slider ${isMobile && isLivePage ? 'm-10' : ''
          }`}
      >
        <div
          styleName="market-ticker-list-wrapper"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <a
            styleName="bq-english-markets-strip"
            className="container"
            href={`/markets?src=mar_ticker`}
            target="_blank"
          >
            <div styleName="markets-title">
              <SvgIcon
                type="economy_red"
                source="image"
                iconStyle={{ width: '13.5px', height: '15px' }}
              />
              <div>MARKETS</div>
              <SvgIcon
                type="ic_chevron_right_new_red"
                source="image"
                iconStyle={{ width: '11.5px', height: '11.5px' }}
              />
            </div>
            <div styleName="market-ticker-wrapper">
              <img styleName="shadow" src="/images/left-shadow.png" />
              <Marquee pauseOnHover={!isMobile}>
                {props.data.length > 0 &&
                  props.data.map((ticker, index) => (
                    <div
                      styleName="indices"
                      key={index}
                      onClick={() => handleClick(get(ticker, ['name'], ''), pageType)}
                    >
                      <div styleName="ticker">
                        <span>{get(ticker, ['name'], '')}</span>
                        <span styleName="ticker-value">
                          {get(ticker, ['priceMovementDto', 'current_price'], 0)}
                        </span>
                        {getTickerChange(get(ticker, ['priceMovementDto']))}
                      </div>
                    </div>
                  ))}
              </Marquee>
              <img styleName="shadow right" src="/images/right-shadow.png" />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

StockTickrList.propTypes = {
  pageType: string,
  data: PropTypes.array,
  sectionName: PropTypes.string,
  config: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    pageType: get(state, ['qt', 'pageType'], 'home-page'),
  };
};

export default connect(mapStateToProps)(StockTickrList);
